import * as React from "react";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import Formula from "../Formula/Formula";
import { SchemaUtils } from "../../util/SchemaUtils";
import {FormulaTotal} from "../../model/FormulaTotal";
import {ControlValueFactory} from "../../factory/ControlValueFactory";
import {Component} from "../../enum/Component";

interface FormulaControlProps {
  data: any;
  label: any;
  description?: any;
  path: string;
  uischema: any;
  schema: any;
  errors: any;
  rootSchema: any;
  handleChange: any;
}

const FormulaControl = ({ errors, uischema, schema, data, handleChange }: FormulaControlProps) => {

  const jsonForms = useJsonForms();

  let visible = SchemaUtils.isComponentVisible(uischema, jsonForms.core!.data);

  const errString = "must be number";

  let total: FormulaTotal|undefined = ControlValueFactory.getControlValue(Component.Formula, data, uischema.scope,
      jsonForms, visible)

  const properties = uischema.scope.split("/properties/");
  const page = properties[1];
  const component = properties[2];
  const type = properties[3];
  let existingTotal = jsonForms.core!.data[page][component][type];
  let presentationValue = '-';

  if(total !== undefined){
    let totalValue = parseFloat(total.value.toFixed(2));
    if(existingTotal !== totalValue && totalValue !== 0){
      jsonForms.core!.data[page][component][type] = totalValue;
    }
    presentationValue = new Intl.NumberFormat(navigator.language.toLocaleLowerCase(), {
      style: 'currency', currency: total.currency
    }).format(total.value);
  }

  return (
      <Formula
          error={errors === errString ? '' : errors}
          value={presentationValue}
          label={uischema.label}
          description={schema.description}
          visible={visible}
      />
  );
};

export default withJsonFormsControlProps(FormulaControl);
